export default __webpack_public_path__ + "static/media/Denim.52cab0c7.webp";